module.exports = __webpack_public_path__ + "img/step-3.511163f6.jpg";